import { render, staticRenderFns } from "./yc-aside.vue?vue&type=template&id=5adaa8fc&"
import script from "./yc-aside.vue?vue&type=script&lang=ts&"
export * from "./yc-aside.vue?vue&type=script&lang=ts&"
import style0 from "./yc-aside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports